export default __webpack_public_path__ + "5b8f3ba886526963a788fb19c016bcee.woff2";